// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://tlvmfrqvnmcbwgkzmpjp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRsdm1mcnF2bm1jYndna3ptcGpwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc2NzE5NzQsImV4cCI6MjA3MzI0Nzk3NH0.JLb1pt7mzfgalPjVxX-rb5JR-82dhiGpN4KdEVcVcOs";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});